import { render, staticRenderFns } from "./sceneImg.vue?vue&type=template&id=b625d4c0&scoped=true"
import script from "./sceneImg.vue?vue&type=script&lang=js"
export * from "./sceneImg.vue?vue&type=script&lang=js"
import style0 from "./sceneImg.vue?vue&type=style&index=0&id=b625d4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b625d4c0",
  null
  
)

export default component.exports